<template>
  <ValidationObserver
    ref="link-student"
  >
    <b-modal
      id="link-student-modal"
      ref="link-student-modal"
      centered
      :title="`Link A ${camperStudent(1)}`"
      ok-title="Save"
      ok-only
      no-close-on-backdrop
      @hidden="closeModal"
    >
      <b-overlay
        id="overlay-background"
        :show="isLoading"
        variant="white"
        opacity="1"
        rounded="sm"
      >
        <b-row>
          <b-col
            sm="12"
            class="mb-1"
          >
            <b-form-group
              label="Email"
            >
              <validation-provider
                #default="{ errors }"
                name="email"
                rules="email|required"
              >
                <b-form-input
                  v-model="parentEmail"
                  type="text"
                  :placeholder="'Email'"
                  :class="{'is-invalid': errors.length > 0 }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-overlay>

      <template #modal-footer>
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          :disabled="isLoading"
          @click="closeModal"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          class="float-right"
          :disabled="isLoading"
          @click="handleForm"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import {
  BModal,
  BRow,
  BCol,
  BFormGroup,
  BButton,
  BFormInput,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import useParentsChildrenList from '@/views/components/parents-children-list/useParentsChildrenList'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BFormInput,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      parentEmail: null,
      isLoading: false,
      validationErrors: '',
      required,
      email,
    }
  },
  setup() {
    const {
      linkStudent,
    } = useParentsChildrenList()

    return {
      linkStudent,
    }
  },
  methods: {
    closeModal() {
      this.parentEmail = null
      this.validationErrors = ''
      this.$refs['link-student-modal'].hide()
    },
    handleForm() {
      this.validationErrors = ''

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        this.$refs['link-student'].validate().then(success => {
          if (success) {
            resolve(true)
            this.sendRequest()
          } else {
            reject()
          }
        })
      })
    },
    async sendRequest() {
      const queryParams = {
        email: this.parentEmail,
        user_id: this.userId,
      }
      this.isLoading = true
      await this.linkStudent(queryParams)
        .then(() => {
          this.$emit('success')
          this.closeModal()
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
